import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
} from "@mantine/core";

import React from "react";
import DocsButton from "../articlesHelpers/DocsButton";
import {
  IconRocket,
  IconArrowBigDownFilled,
  IconBoltFilled,
  IconExchange,
} from "@tabler/icons-react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";

export const INBOUND_BALANCE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Inbound Capacity is the total amount of Bitcoin that can be received over
      your lightning channels. This is calculated by adding up the inbound
      capacity of all of your lightning channels.
    </p>

    <p>
      You need Inbound Capacity to receive payments on the Lightning Network.
    </p>

    <p>
      There are at least two strategies for increasing your inbound capacity:
    </p>

    <DocsHighlightCard>
      <Title order={4}>Get Inbound Capacity: Strategy #1</Title>
      <p>
        This is very quick. If you use the "Get Inbound" button, our LSP
        (Lightning Service Provider) node instantly opens a channel to your
        node.
      </p>

      <DocsButton
        ariaLabel="get inbound"
        text="Get Inbound"
        leftSection={<IconRocket />}
      />
      <p>
        To get this channel, you'll be asked to make a small payment via
        Lightning. So you need to already have some funds in a wallet that can
        send lightning payments.
      </p>
    </DocsHighlightCard>

    <DocsHighlightCard>
      <Title order={4}>Get Inbound Capacity: Strategy #2</Title>
      <p>
        This approach involves using on-chain Bitcoin. It requires some on-chain
        funds and a few additional steps.
      </p>
      <p>First, deposit BTC to your Rizful node:</p>
      <DocsButton
        ariaLabel="deposit btc"
        text="Deposit BTC"
        leftSection={<IconArrowBigDownFilled />}
      />
      <p>
        Make sure you follow the recommendations on that screen. Rizful Node
        won't let you open a channel less than a certain size, so there is a
        minimum you need to deposit if this is what you want to do.
      </p>
      <p>
        Next, wait for the funds to confirm... could be five minutes, could be
        thirty minutes, it depends on the blockchain...
      </p>
      <p>
        When you see that the funds are no longer "pending" -- then, open a
        channel:
      </p>
      <DocsButton
        ariaLabel="open channel to peer"
        text="Open Channel"
        leftSection={<IconExchange />}
      />

      <p>
        Finally, send a large payment through the channel to a wallet that you
        control on an outside service --- for example another wallet or an
        exchange:
      </p>
      <DocsButton
        ariaLabel="send lightning"
        text="Send Lightning"
        leftSection={<IconBoltFilled />}
      />

      <p>
        This outgoing payment will send funds to the "remote side" or "other
        side" of the channel, thereby increasing your Inbound Capacity by the
        amount of the payment. Cool, right?
      </p>
    </DocsHighlightCard>
  </TypographyStylesProvider>
);
